<div #pixiItemEditor></div>
<div class="zoom-controls">
  <button
    type="button"
    title="Zoom In"
    id="btnZoomIn"
    class="zoom-button p-2"
    (mousedown)="startZoom(true)"
    (mouseup)="stopZoom()"
    (mouseleave)="stopZoom()"
    [disabled]="inDisabled"
    [ngClass]="{ active: zoomDirection.value === 'in', disabled: inDisabled }"
    data-test-id="zoom-in-button"
  >
    <mat-icon svgIcon="PLUS"></mat-icon>
  </button>
  <button
    type="button"
    title="Zoom Out"
    id="btnZoomOut"
    class="zoom-button p-2"
    (mousedown)="startZoom(false)"
    (mouseup)="stopZoom()"
    (mouseleave)="stopZoom()"
    [disabled]="outDisabled"
    [ngClass]="{ active: zoomDirection.value === 'out', disabled: outDisabled }"
    data-test-id="zoom-out-button"
  >
    <mat-icon svgIcon="MINUS"></mat-icon>
  </button>
  <button title="Reset Zoom" class="zoom-button" type="button" (click)="resetZoom()">
    <mat-icon [color]="'black'" fontIcon="refresh"></mat-icon>
  </button>
</div>
